<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-16 11:23:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\ExportIn.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-22 10:02:53
-->
<template>
  <normalDialog
    :dialog="show"
    width="680"
    :title="$t('label_essweb_RosterRecord_dialog_ExportInTitle')"
    maxWidth="680"
    pad="3"
    @close="closeDialog"
  >
    <template v-slot:content>
      <Stepper
        :curStep="curStep"
        :items="stepper"
        backgroundColor="white pa-0 ma-0"
      >
        <template v-slot:content-1>
          <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <FileDragUpdate
                ref="upload"
                url="/roster/import/"
                single
                tempplateUrl="https://assets.essencehr.io/web/ess-business/assets/roster-import-template.xlsx"
                :reload="toReload"
                @change="onChange"
                :title="$t('label_essweb_rosterRecord_dialog_fileLabel')"
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:content-2>
          <v-sheet height="300" class="text-center d-flex align-center">
            <v-sheet v-if="isSuccess" class="text-center max-width">
              <span>{{
                $t("message_essweb_rosterRecord_dialog_exportInSuccessLabel")
              }}</span>
            </v-sheet>
            <v-sheet v-else class="text-center max-width">
              <span>{{
                $t("message_essweb_rosterRecord_dialog_exportInFailLabel")
              }}</span
              ><br />
              <v-btn
                text
                :ripple="false"
                small
                rounded
                depressed
                color="primary"
                @click="showMessage = true"
                class="primary--text text-decoration-underline"
                >{{
                  $t("label_essweb_rosterRecord_dialog_errorMessageBtnLabel")
                }}</v-btn
              >
              <!-- <span
                class="primary--text text-decoration-underline"
                @click="showMessage = true"
                >{{
                  $t("label_essweb_rosterRecord_dialog_errorMessageBtnLabel")
                }}</span 
              >-->
            </v-sheet>
          </v-sheet>
        </template>
      </Stepper>
    </template>
    <template v-slot:actions>
      <CardActions
        :saveBtn="curStep != 1"
        :saveText="text"
        :okBtnDisabled="curStep == 1"
        @save="curStep == 2 && !isSuccess ? toReUpLoad() : closeDialog()"
        @cancel="closeDialog"
      />
      <ErrorMessage
        :show="showMessage"
        @close="showMessage = false"
        :items="fileData"
        :downloadUrl="downloadUrl"
      />
    </template>
  </normalDialog>
</template>
<script>
import ErrorMessage from "@/Page/EssAdmin/Roster/RosterRecord/components/ErrorMessage";
export default {
  name: "ExportIn",
  components: { ErrorMessage },
  props: {
    show: { default: false, type: Boolean },
  },
  computed: {
    text() {
      let isd = this.curStep == 2 && !this.isSuccess;
      if (!this.isSuccess) {
        isd = true;
      }
      return isd
        ? "label_essweb_rosterRecord_dialog_reUploadBtnLabel"
        : "label_Complete";
    },
  },
  watch: {
    show() {
      this.curStep = 1;
    },
  },
  data() {
    return {
      curStep: 1,
      uploadData: null,
      downloadUrl: "",
      toReload: 123,
      isSuccess: false,
      showMessage: false,
      fileData: [],
      stepper: [
        "label_essweb_rosterRecord_dialog_step_exportInLabel",
        "label_essweb_rosterRecord_dialog_step_resultLabel",
      ],
    };
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    toReUpLoad: function () {
      const that = this;
      this.curStep = 1;
      that.toReload = Math.random() * 10000000;
    },
    showError: function () {
      const that = this;
      this.closeDialog();
      this.$Sleep(500).then(() => {
        that.showMessage = true;
      });
    },
    onSubmit: function () {},
    onChange: function (data) {
      const that = this;
      this.$Sleep(300).then(() => {
        if (data)
          if (data["code"] == 200) {
            that.isSuccess = true;
            that.fileData = data["data"];
            that.curStep = 2;
            that.$emit("export", true); //刷新
          } else {
            that.isSuccess = false;
            that.fileData = data["data"]["excel_errors"]
              ? data["data"]["excel_errors"]
              : [];
            that.downloadUrl = data["data"]["download_url"]
              ? data["data"]["download_url"]
              : "";
            that.curStep = 2;
          }
      });
    },
  },
};
</script>